module.exports = __webpack_public_path__ + "static/media/RishiSharma@3x.a93e0593.png";